import type { Option } from '@usealloy/component-library';

export const pendingCloseGroupOptions: Option[] = [
  {
    label: 'Close Group',
    value: 'close',
  },
  {
    label: 'Cancel opening this group',
    value: 'cancel',
  },
];
